import { IDiagnosticNotification } from 'utils/interfaces'
import { create } from 'zustand'

interface DiagnosticStore {
  notifications: IDiagnosticNotification[]
  addNotification: (notification: IDiagnosticNotification) => void
  removeNotification: (id: string) => void
  clearNotifications: () => void
  updateNotification: (id: string, update: Partial<IDiagnosticNotification>) => void
  /** Заменяет наборы по robot_id каждого элемента (для глобального канала). */
  replaceRobotNotifications: (notifications: IDiagnosticNotification[]) => void
}

const useDiagnosticStore = create<DiagnosticStore>((set, get) => ({
  notifications: [],
  addNotification: (notification: IDiagnosticNotification) => {
    const exists = get().notifications.find(n => n.notification_id === notification.notification_id)
    if (exists) {
      get().updateNotification(notification.notification_id, notification)
      return
    }
    set({ notifications: [...get().notifications, notification] })
  },
  removeNotification: (id: string) =>
    set({ notifications: get().notifications.filter(n => n.notification_id !== id) }),
  clearNotifications: () => set({ notifications: [] }),
  updateNotification: (id: string, update: Partial<IDiagnosticNotification>) =>
    set({
      notifications: get().notifications.map(n =>
        n.notification_id === id ? { ...n, ...update } : n
      ),
    }),
  replaceRobotNotifications: incoming => {
    const ids = new Set(incoming.map(n => n.robot_id))
    const keep = get().notifications.filter(n => !ids.has(n.robot_id))
    set({ notifications: [...keep, ...incoming] })
  },
}))

export default useDiagnosticStore